module.exports = __webpack_public_path__ + "img/pgn08.0d01d1cb.png";